import React from "react";
import { Skeleton } from "./Skeleton";

/**
 * Skeleton loader for the 12-Month Trend section (Revenue vs Expenses and Cash In/Out cards).
 */
export function TwelveMonthTrendSkeleton() {
  return (
    <div className="flex w-full max-w-full min-w-0 flex-col items-start gap-4 rounded-2xl bg-neutral-50 overflow-hidden">
      <div className="flex w-full justify-between pb-2 items-baseline">
        <div className="flex items-center gap-2">
          <div className="flex h-4 w-0.5 flex-none flex-col items-start bg-neutral-200 rounded" />
          <Skeleton className="h-4 w-28" />
        </div>
        <Skeleton className="h-4 w-48" />
      </div>
      {/* Revenue vs Expenses card skeleton */}
      <div className="flex w-full gap-4 rounded-lg border border-solid border-neutral-200 bg-white px-8 py-8 shadow-sm">
        <div className="flex flex-1 flex-col gap-4">
          <Skeleton className="h-4 w-56" />
          <div className="flex items-end gap-4">
            <div className="flex flex-col gap-8 pb-6">
              {[0, 1, 2, 3, 4].map((i) => (
                <Skeleton key={i} className="h-4 w-10" />
              ))}
            </div>
            <div className="flex flex-1 gap-1 h-56 items-end">
              {Array.from({ length: 12 }, (_, i) => (
                <div key={i} className="flex flex-1 gap-0.5 items-end">
                  <Skeleton className="w-4 h-20 rounded-t-sm" />
                  <Skeleton className="w-4 h-16 rounded-t-sm" />
                </div>
              ))}
            </div>
          </div>
          <div className="flex w-full justify-between pt-4">
            {Array.from({ length: 12 }, (_, i) => (
              <Skeleton key={i} className="h-4 w-8" />
            ))}
          </div>
        </div>
        <div className="flex w-96 flex-none flex-col gap-4 rounded-r-lg border-l-4 border-neutral-200 bg-neutral-50 px-6 py-6">
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      </div>
      {/* Cash In/Out card skeleton */}
      <div className="flex w-full gap-4 rounded-lg bg-default-background px-4 py-4 shadow-md">
        <div className="flex flex-col gap-4 px-6 py-6 flex-[2]">
          <Skeleton className="h-4 w-36" />
          <div className="flex items-end gap-3">
            <div className="flex flex-col gap-8 pb-8">
              {[0, 1, 2, 3, 4].map((i) => (
                <Skeleton key={i} className="h-4 w-10" />
              ))}
            </div>
            <div className="flex flex-1 h-64 items-end">
              <Skeleton className="w-full h-40 rounded" />
            </div>
          </div>
          <div className="flex w-full justify-between pt-3">
            {Array.from({ length: 12 }, (_, i) => (
              <Skeleton key={i} className="h-4 w-8" />
            ))}
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-3 border-l-2 border-neutral-200 bg-[#f0fdfa] px-6 py-6">
          <Skeleton className="h-6 w-32" />
          <Skeleton className="h-4 w-full" />
        </div>
      </div>
    </div>
  );
}
